import { createApp } from 'vue'
import TangentCalculator from './TangentCalculator.vue'
import './assets/global.css'

createApp(TangentCalculator).mount('#tangent')
